<li>
  <form [formGroup]="categoryForm">
    <sui-checkbox
      [checked]="category.is_selected"
      (checkedChange)="onCheckboxChange($event)"
    >
      {{ category.name }}
      @if (category.selected_count > 0) {
        <span class="selected-count"> ({{ category.selected_count }})</span>
      }
    </sui-checkbox>
  </form>
  @if (category.children && category.children.length) {
    <ul>
      @for (child of category.children; track child) {
        <app-category
          [category]="child"
          [categoryForm]="categoryForm"
        ></app-category>
      }
    </ul>
  }
</li>
